import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Typo } from 'tmt-ui-kit';
import xss from 'xss';

import { stripLink } from '~/utils/helpers';
import ReviewTraveler from './ReviewTraveler';

const Container = styled.div`
  padding-top: 16px;
  border-top: 1px solid ${props => props.theme.blueGray};
`;

const ReviewText = styled(Typo.Paragraph)`
  margin: 0px;
`;

const UserContainer = styled.div`
  padding-top: 8px;
`;

const ReplyItem = ({ reply, user, url }) => {
  const { text } = reply;
  const fullPath = url && url.query && url.query.fullPath;
  return (
    <Container>
      {text && text.split('\n').map((line, idx) => (
        <ReviewText
          key={idx}
          dangerouslySetInnerHTML={{ __html: xss(fullPath ? stripLink(line, fullPath) : line) }}
        />
      ))}
      <UserContainer>
        <ReviewTraveler traveler={user} createdAt={reply.created_at} />
      </UserContainer>
    </Container>
  );
};

ReplyItem.propTypes = {
  reply: PropTypes.object,
  user: PropTypes.object,
  url: PropTypes.string,
};

export default ReplyItem;
